import React from "react";
import FingerprintIcon from "../../../assets/images/generico/FingerprintIcon";
import { IonSpinner } from "@ionic/react";
import "./BiometricButton.css";

const BiometricButton = ({
  onClick,
  loading = false,
  disabled = false,
  biometryTypeName = "Huella Digital",
  lastUser = null,
}) => {
  return (
    <div className="biometric-button-container">
      <button
        className={`biometric-button ${
          disabled ? "biometric-button-disabled" : ""
        }`}
        onClick={onClick}
        disabled={disabled || loading}
      >
        <div className="biometric-button-content">
          {loading ? (
            <IonSpinner name="lines" className="biometric-spinner" />
          ) : (
            <FingerprintIcon color="var(--color-latex30)" width={24} height={24} />
          )}
          <div className="biometric-button-text">
            <span className="rb14m c-latex30">
              {loading ? "Autenticando..." : `Entrar con ${biometryTypeName}`}
            </span>
            {lastUser && !loading && (
              <span className="rb11m c-grey45 biometric-last-user">
                DNI: {lastUser}
              </span>
            )}
          </div>
        </div>
      </button>
    </div>
  );
};

export default BiometricButton;

